<template>
  <Modal :title="getTitle()" @close="close" :hide-footer="true">
    <template #body>
      <LoadingState v-if="isLoading()" :size="50" />
      <ErrorState v-else-if="isErrored()" />
      <DevSiteAddForm
        v-else-if="isLoaded()"
        :plan="data.plan"
        :site="data.site"
        :package="getPackage()"
        :environment-type="data.environmentType"
        :packages="packages"
        :location-id="getLocationId()"
        :safe-harbor="data.safeHarbor"
        @cancel="close"
        @success="close"
      />
    </template>
  </Modal>
</template>

<script>
import { computed } from "@vue/composition-api";
import DevSiteAddForm from "@/components/smart/forms/DevSiteAddForm";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import Modal from "@/components/display/Modal";
import { onMounted } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "DevSiteAdd",
  components: {
    Modal,
    DevSiteAddForm,
    ErrorState,
    LoadingState,
  },
  props: {
    data: {
      type: Object,
      validator: (value) => {
        let validSite = true;
        if (value.site && typeof value.site !== "object") {
          validSite = false;
        }
        const validPlan = !!value.plan && typeof value.plan === "object";
        const validEnv =
          !!value.environmentType &&
          typeof value.environmentType === "string" &&
          ["development", "staging"].includes(value.environmentType);

        return validSite && validPlan && validEnv;
      },
    },
  },
  setup(props, { emit, root }) {
    const { environmentType, plan } = props.data;
    const locations = computed(() => store.getters["locations/getList"]);
    const locationsStatus = computed(() => store.getters["locations/getStatus"]);
    const packages = computed(() => store.getters["packages/getDevList"]);
    const packagesStatus = computed(() => store.getters["packages/getDevListStatus"]);
    const getPackage = () => {
      if (environmentType === "staging" || props.data.safeHarbor === "site") {
        return packages.value.find(({ label }) => label === plan.package.label);
      }
      return null;
    };

    const getTitle = () =>
      root.$t(
        environmentType === "staging"
          ? "global.add-staging-environment"
          : "global.add-dev-environment"
      );

    const getLocationId = () => {
      if (props.data.safeHarbor === "shared") {
        return (
          locations.value?.find((item) => item?.id === props.data.plan.cloudId)?.id ||
          locations.value[0]?.id
        );
      }
      return undefined;
    };

    const isErrored = () =>
      props.data.site ? packagesStatus.value.isErrored : locationsStatus.value.isErrored;
    const isLoaded = () =>
      props.data.site
        ? packagesStatus.value.isLoaded || packagesStatus.value.isUpdating
        : locationsStatus.value.isLoaded || locationsStatus.value.isUpdating;
    const isLoading = () =>
      props.data.site ? packagesStatus.value.isLoading : locationsStatus.value.isLoading;

    const close = () => {
      emit("close");
    };

    onMounted(() => {
      if (props.data.site) {
        store.dispatch("packages/getDevList", { environmentType });
      } else {
        store.dispatch("locations/getList");
      }
    });

    return {
      close,
      isErrored,
      isLoaded,
      isLoading,
      getLocationId,
      getPackage,
      getTitle,
      packages,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
